module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-3.32a1c4ae.svg";